import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Spinner from '../components/Spinner';
import LoadingOverlay from '../components/LoadingOverlay';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

Modal.defaultProps = {
    showTitle: true,
    showActions: true
};

export default function Modal(props) {
    const {
        open,
        loading,
        loadingText,
        handleClose,
        confirmacion,
        accion,
        xl,
        title,
        fullWidth,
        maxWidth,
        disableBackClick,
        disableEscapeKey,
        botonSi,
        botonNo,
        showTitle,
        showActions,
        style
    } = props;

    return (
        <div>
            <Dialog
                disableBackdropClick={disableBackClick ? disableBackClick : false}
                disableEscapeKeyDown={disableEscapeKey ? disableEscapeKey : false}
                open={open}
                maxWidth={xl ? 'xl' : maxWidth ? maxWidth : 'sm'}
                fullWidth={fullWidth ? true : false}
                TransitionComponent={Transition}
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{ style: style }}>
                {showTitle && (
                    <DialogTitle id="alert-dialog-slide-title">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <span>{title ? title : accion ? 'Confirmación' : 'Notificación'}</span>
                            {handleClose && (
                                <IconButton
                                    aria-label="close"
                                    onClick={handleClose}
                                    style={{ padding: 8, marginRight: -8 }}>
                                    <CloseIcon />
                                </IconButton>
                            )}
                        </div>
                    </DialogTitle>
                )}
                <DialogContent>
                    {loading ? (
                        loadingText ? <LoadingOverlay text={loadingText} /> : <Spinner />
                    ) : (
                        props.children
                    )}
                </DialogContent>
                {showActions && (
                    <DialogActions>
                        <div>
                            <Button onClick={handleClose} color="secondary">
                                {botonNo ? botonNo : 'Cerrar'}
                            </Button>
                            {confirmacion && (
                                <Button onClick={accion} disabled={loading ? true : false} color="primary">
                                    {botonSi ? botonSi : 'Aceptar'}
                                </Button>
                            )}
                        </div>
                    </DialogActions>
                )}
            </Dialog>
        </div>
    );
}
